import api from './api'
import { parseParams } from './common'

export default {
  getConf ({ id, ...params }) {
    const urlParams = parseParams(params)
    return api.get(`/siteprofiles/${id}?${urlParams}`).then(res => res.data)
  },
  getConfs (params) {
    const urlParams = parseParams(params)
    return api.get(`/siteprofiles?${urlParams}`).then(res => res.data)
  },
  editConf ({ id, ...body }) {
    return api.put(`/siteprofiles/${id}`, body).then(res => res.data)
  }
}
